module.exports = __webpack_public_path__ + "amcharts/images/xIcon.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIcon.png
// module id = 283
// module chunks = 0